const $ = require('jquery');

const ctaClick = function () {
 $.fcutrecht = $.ajax;

    $(".js-cta").on('click', function (e) {
		const msg = this;
        $.fcutrecht({
            type: "POST",
            url: "/umbraco/api/MessageBox/MessageRead",
            dataType: "json",
            contentType: "application/json",
            data: $(this).attr("data"),
            success: function (e) { 
				const subj = msg.getElementsByClassName('inbox-subject')[0];
				if(subj){
					subj.className = 'inbox-subject';
				}
				console.log("success", e); 
			},
            error: function (e) { console.log("error", e); }
        });
    });
}

module.exports = ctaClick;